<template>
  <component
    :is="tag"
    class="text"
    :class="modifiers"
    v-html="text"
  />
</template>

<script>
export default {
  name: 'BaseText',
  props: {
    text: {
      type: String,
      default: '',
    },
    tag: {
      type: String,
      default() {
        return this.text.includes('<') ? 'div' : 'p';
      },
    },
    size: {
      type: String,
      default: '',
    },
    theme: {
      type: String,
      default: '',
    },
    isCenter: {
      type: Boolean,
      default: false,
    },
    isUp: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    modifiers() {
      return {
        [`text_size_${this.size}`]: Boolean(this.size),
        [`text_theme_${this.theme}`]: Boolean(this.theme),
        text_center: this.isCenter,
        text_up: this.isUp,
      };
    },
  },
};
</script>

<style lang="stylus">
.text
  display block
  margin 0
  padding 0
  font-size 1em
  line-height 1.4

  p
    display block
    margin 0

  h4
    margin 0
    margin-bottom 0.8em

  ul
    padding-left 1.5em

  * + h4
    font-size 1.1em
    margin-top 2.25em

  p + p
    margin-top 0.8em

  &_center
    text-align center

  &_up
    text-transform uppercase

  &_size_xxs
    font-size 0.7em

  &_size_xs
    font-size 0.8em

  &_size_s
    font-size 0.9em

  &_size_m
    font-size 1.1em

  &_size_l
    font-size 1.2em

  &_size_xl
    font-size 1.3em

  &_size_xxl
    font-size 2em

  &_theme_dim
    color $c_text_dim

  &_theme_bright
    color $c_text_bright

  &_theme_note
    display block
    background-color $c_tip
    color darken(@background-color, 68%)
    padding 1em 1.5em
</style>
